<button
    class="scroll-to-top"
    [hasIcon]="true"
    [name]="'common.button-to-top' | translate"
    lsUiButtonKind="basic"
    lsUiButtonPalette="neutral-1"
    lsUiButtonSize="small"
    lsUiScrollToTop
>
    <ls-ui-icon
        class="scroll-to-top__icon"
        height="24"
        src="chevron"
        width="24"
    ></ls-ui-icon>
</button>
